import BannerOne from "../HomePage/Technology/AllBanner/BannerOne";
import Main from "./Main/Main";
import { useEffect } from "react";
import FooterContact from "../FooterContactPage/FooterContact";
import TechPertnership from "./TechPartnership/TechPartenership";
import { Helmet } from "react-helmet-async";

const TechlogiesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        <title>Technology Partnerships Built In Real Projects | Quad Theory Ltd</title>
        <meta
          name="description"
          content="Discover how Quad Theory Ltd builds technology partnerships through real world projects, deployments, and long term collaboration. Practical partnerships shaped by live systems, not surface level integrations."
        />
      </Helmet>
      <BannerOne />
      <Main />
      <TechPertnership />
      <FooterContact />
    </div>
  );
};

export default TechlogiesPage;
